export enum EnvType {
    Local = 'Local',
    Dev = 'Dev',
    QA = 'QA',
    USGovStage = 'usgov-stage',
    Stage = 'Stage',
    Prod = 'usgov',
    CommProd = 'Commerical Production',
    PreProdSec = 'CCCS Preprod',
    ProdSec = 'CCCS Prod',
    CAComm = 'CA Commercial Production',
    AUProd = 'AU Commercial Production',
    FedStage = 'Fed Stage',
    FedProd = 'Fed Prod'
}
